import { canApproveForm } from '../onboarding-action-policy.service';
import templateUrl from './i9.component.html';
import { SignaturePadModal } from '../signature/signature-pad.component';
import moment from 'moment';
import { PreviewSignatureModal } from '../preview-signature-modal/preview-signature-modal.component';
import { InfoModal } from '../info-modal/info-modal.component';
import { OwnerPreviewSignatureModal } from '../preview-signature-modal/owner-preview-signature-modal.component';

export const I9Component = {
    templateUrl,
    controller: I9Controller,
    controllerAs: "vm",
    bindings: {
        resolve: "<",
        ownerView: "<",
        owner: "<",
        employee: "<",
        employeeProfile: "<",
        profile: "<",
        employeeBankInfo: "<",
        provinces: "<",
        application: "<",
        genderOptions: "<",
        userInputs: "<",
        savedInputs: "<",
        maritalStatus: "<",
        addlInputs: "<",
        ownerInfo: "<",
        close: "&",
        dismiss: "&"
    }
};

function I9Controller(onboardingActionPolicy, $stateParams, $state, $timeout, $uibModal, $rootScope, $scope, $q, onboardingDocumentService,
    onboardingDocumentViewService, utilityService, employeeService, localeService, stateProvinceService) {
    'ngInject';
    const vm = this;
    // APEX-977: read-only View mode (locked forms) - hides inline Edit, keeps fields disabled.
    vm.isViewOnly = () => !!vm.application && onboardingActionPolicy.getButtonTitle('3', vm.application) === 'View';
    vm.state = {
        view: 'I9'
    };

    vm.datePickerOptions = {
        max: new Date()
        //change: function () {
        //    vm.editForm.DateOfBirth.$setTouched();
        //}
    };

    vm.onShowDirectDeposit = onShowDirectDeposit;
    vm.listToggle = false;
    vm.selectedList = 'A';
    vm.validateListAFields = validateListAFields();
    vm.validateListBFields = validateListBFields();
    vm.onToggleChange = onToggleChange;
    vm.handlePreparerChange = handlePreparerChange;
    vm.onSign = onSign;
    vm.onDocDownload = onDocDownload;
    vm.onEditClicked = onEditClicked;
    vm.I9EmployerForm
    vm.I9Form = {};
    vm.stateProvinces;
    vm.onPreview = onPreview;
    vm.onSubmit = onSubmit;
    vm.onSave = onSave;
    vm.onClose = onClose;
    vm.onPreviewInPage = onPreviewInPage;
    vm.onChangeCB = onChangeCB;
    vm.validateFutureDate = validateFutureDate;
    vm.validateStep3 = validateStep3;
    vm.validateStep4 = validateStep4;
    vm.cancel = cancel;
    vm.employeeID = $stateParams.employeeID;
    vm.isEmployerMode = false;
    vm.isSaved = false;
    vm.empState = '';
    vm.revealSSNChar = revealSSNChar;
    vm.revealFEINChar = revealFEINChar;
    vm.ssnIsValidated = ssnIsValidated;
    vm.validateEmployerDates = validateEmployerDates;
    vm.ssnBlur = ssnBlur;
    vm.retrieveLocale = retrieveLocale;
    vm.retrieveLocaleTranslations = retrieveLocaleTranslations;
    vm.originalSSN;
    vm.fillLockedInfo = fillLockedInfo;
    vm.reqReview = false;
    vm.canApproveForm = (rt) => canApproveForm(vm.application, rt);
    vm.isSigned = false;
    vm.disableEmpFields = true;
    vm.prefilled = false;
    vm.editable = true;
    vm.showSavedNotification = false;
    vm.savedData = false;
    vm.previewUrl;
    vm.requestReview = requestReview;
    vm.today = new Date();

    vm.$onInit = function () {
        if (vm.resolve) {
            Object.assign(vm, vm.resolve);
        }
        vm.reqReview = false;
        vm.userProfile = this.profile;
        //utilityService.showLoading();
        vm.stateProvinces = this.provinces;

        vm.todaysDate = moment(new Date, 'MM/DD/YYYY').toDate();
        vm.date = moment(new Date, 'MM/DD/YYYY').toDate();
        //vm.isEmployerMode = true;
        vm.isEmployerMode = vm.employeeID != null;
        //test();
        if (vm.isOwnerView) {
            //fillEmployee();
            //test2()
            vm.todaysDate2 = moment(new Date, 'MM/DD/YYYY').toDate();
            //vm.date3 = new Date();
        }
        vm.isSiteAdmin = this.employee.IsSiteAdmin;
        vm.employeeBankInfo = this.employeeBankInfo;
        vm.retrieveLocale()
            .then(function (locale) {
                console.log(locale);
                vm.employeeBankInfo.LocaleID = locale.localeID;
                vm.employeeBankInfo.ShowMaritalStatus = vm.employeeBankInfo.CountryID === 1;
                return vm.retrieveLocaleTranslations(locale.localeID);
            })
            .then(function (translations) {
                vm.employeeBankInfo.Translations = translations;
                console.log(vm.employeeBankInfo);
            });
        vm.uscis = null;
        vm.alienExpirationDate = null;
        vm.foreignPassportNumber = null;
        vm.countryOfIssue = null;
        vm.i94 = null;
        //Set MI Toggle value on load
        if (vm.addlInputs.hasOwnProperty("ListToggle")) {
            vm.listToggle = vm.addlInputs["ListToggle"] === "true";
        } else {
            onListToggle(vm.listToggle);
        }
        validateFields(vm.listToggle);
        if (vm.savedInputs != null && vm.savedInputs.FirstName != null && !vm.ownerView) {
            console.log(vm.savedInputs);
            vm.savedData = true;
            vm.showSavedNotification = true;
            vm.isPrefilling = true;
            fillEmployee(vm.savedInputs);
            //default to user profile info
            vm.email = this.profile.EmailAddress;
            vm.firstName = this.profile.FirstName;
            vm.lastName = this.profile.LastName;
            vm.middleInitial = this.profile.MiddleName?.charAt(0) ?? null;
            vm.otherLastNames = null;
            // todo: check for deleted phone numbers
            vm.telephone = this.profile?.HomePhone?.PhoneNumber;
            vm.dob = this.profile.DateOfBirth;
            if (this.profile.HomeAddress != null) {
                // todo: check if streetline2 needs to be added
                vm.address = [this.profile.HomeAddress.StreetLine1, this.profile.HomeAddress.StreetLine2].filter(Boolean).join(', ');
                vm.apt = this.profile.HomeAddress.AptNum;
                vm.city = this.profile.HomeAddress.City;
                /*vm.stateProvince = vm.stateProvinces.find(x => x.StateProvinceID === this.profile.HomeAddress?.StateProvinceID)*/
                vm.zip = this.profile.HomeAddress.PostalCode;
                vm.stateProvince = this.stateProvinces.find(x => x.StateProvinceID === this.profile.HomeAddress?.StateProvinceID);
            }
            $timeout(function () {
                vm.isPrefilling = false;
                validateFutureDate();
            });
        } else if (this.userInputs != null && this.userInputs.FirstName != null) {
            if (this.application) {
                vm.editable = !(this.application && this.application.HasI9Form !== null && this.application.I9Form !== 'Review' && this.application.I9Form !== 'Submitted' && this.application.I9Form !== 'Pending');
            }
            vm.isPrefilling = true;
            fillEmployee(this.userInputs);
            
            if (vm.application.I9Form === "Pending") {
                fillLockedInfo();
            }
            $timeout(function () {
                vm.isPrefilling = false;
                validateFutureDate();
            });
        } else {
            //employee
            vm.employmentRecord = this.employeeProfile.IcdOffices[0];
            //userthis.profile
            vm.email = this.profile.EmailAddress;
            vm.firstName = this.profile.FirstName;
            vm.lastName = this.profile.LastName;
            vm.middleInitial = this.profile.MiddleName?.charAt(0) ?? null;
            vm.otherLastNames = null;
            // todo: check for deleted phone numbers
            vm.telephone = this.profile?.HomePhone?.PhoneNumber;
            vm.dob = this.profile.DateOfBirth;
            if (this.profile.HomeAddress != null) {
                // todo: check if streetline2 needs to be added
                //vm.address = this.profile.HomeAddress.StreetLine1;
                vm.address = [this.profile.HomeAddress.StreetLine1, this.profile.HomeAddress.StreetLine2].filter(Boolean).join(', ');
                vm.apt = this.profile.HomeAddress.AptNum;
                vm.city = this.profile.HomeAddress.City;
                /*vm.stateProvince = vm.stateProvinces.find(x => x.StateProvinceID === this.profile.HomeAddress?.StateProvinceID)*/
                vm.zip = this.profile.HomeAddress.PostalCode;
                vm.stateProvince = this.stateProvinces.find(x => x.StateProvinceID === this.profile.HomeAddress?.StateProvinceID);
            }

            //bankinfo
            //vm.ssn = this.employeeBankInfo.CurrentSSN
            //vm.confirmSSN = this.employeeBankInfo.CurrentSSN
            console.log(this.employeeBankInfo.StateAbbrevation);
            //if (this.employeeBankInfo.StateAbbrevation !== '') {
            //    vm.empState = vm.stateProvinces.find(x => x.Abbr === this.employeeBankInfo.StateAbbrevation);
            //}
        }
        if (vm.application.ApplicationStatus === 'Approved' || vm.application.ApplicationStatus === 'Submitted') {
            vm.editable = false;
        }
        if (vm.ownerView) {
            if (this.userInputs != null && this.userInputs.EmployerBusinessAddress != null) { //owner inputs
                vm.employerBusinessAddress = this.userInputs.EmployerBusinessAddress;
                vm.employerName = this.userInputs.Employername;
                vm.employerBusinessName = this.userInputs.EmployerBusinessName;
                vm.empDate = moment(this.userInputs.EmploymentFirstDay, 'DD/MM/YYYY').toDate();
            } else if (vm.ownerInfo) {
                if (vm.ownerInfo.ShippingAddress) {
                    vm.employerBusinessAddress = [vm.ownerInfo.ShippingAddress.StreetLine1, vm.ownerInfo.ShippingAddress.StreetLine2, vm.ownerInfo.ShippingAddress.AptNum, vm.ownerInfo.ShippingAddress.City, vm.ownerInfo.ShippingAddress.StateName, vm.ownerInfo.ShippingAddress.PostalCode, vm.ownerInfo.ShippingAddress.CountryName].filter(Boolean).join(', ');
                }
                //APEX-376
                vm.employerName = vm.owner.LastName + ", " + vm.owner.FirstName;
                if (vm.owner != null && vm.owner.Roles != null && vm.owner.Roles.length > 0) {
                    if (vm.owner.Roles.includes("Owner")) {
                        vm.employerName = vm.employerName + " - President"
                    } else if (vm.owner.Roles.includes("ICD Payroll Admin")) {
                        vm.employerName = vm.employerName + " - Administrator"
                    }
                }

                vm.employerBusinessName = vm.ownerInfo.LegalBusinessName || vm.ownerInfo.ClientName;
                vm.empDate = moment(vm.resolve.employeeProfile.IcdOffices[0].HireDate, 'DD/MM/YYYY').toDate();
            }
        }
        vm.editable = resolveEditable();
        utilityService.hideLoading();

    }

    function resolveEditable() {
        const appStatus = vm.application.ApplicationStatus;
        const formStatus = vm.application.I9Form;

        // ReviewRequired: always directly editable so the employee can fix it
        if (formStatus === 'ReviewRequired') return true;
        if (appStatus === 'Approved' || appStatus === 'Submitted') return false;
        // Submitted or Approved form: locked so the Edit button shows
        if (formStatus === 'Submitted' || formStatus === 'Approved') return false;
        if (appStatus === 'Pending') {
            // Active employees: skip edit button, directly editable
            // Pending employees (new hire): start locked so edit button is shown
            return formStatus === 'Pending' || vm.application.EmployeeStatus !== 'Pending';
        }

        return !vm.application.HasI9Form
            || formStatus === 'Pending'
            || formStatus === 'ReviewRequired';
    }

    function fillLockedInfo() {
        vm.email = vm.profile.EmailAddress;
        vm.firstName = vm.profile.FirstName;
        vm.lastName = vm.profile.LastName;
        vm.middleInitial = vm.profile.MiddleName?.charAt(0) ?? null;
        vm.otherLastNames = null;
        // todo: check for deleted phone numbers
        vm.telephone = vm.profile?.HomePhone?.PhoneNumber;
        vm.dob = vm.profile.DateOfBirth;
        if (vm.profile.HomeAddress != null) {
            // todo: check if streetline2 needs to be added
            vm.address = [vm.profile.HomeAddress.StreetLine1, vm.profile.HomeAddress.StreetLine2].filter(Boolean).join(', ');
            vm.apt = vm.profile.HomeAddress.AptNum;
            vm.city = vm.profile.HomeAddress.City;
            /*vm.stateProvince = vm.stateProvinces.find(x => x.StateProvinceID === vm.profile.HomeAddress?.StateProvinceID)*/
            vm.zip = vm.profile.HomeAddress.PostalCode;
            vm.stateProvince = vm.stateProvinces.find(x => x.StateProvinceID === vm.profile.HomeAddress?.StateProvinceID);
        }
    }

    function fillEmployee(data) {
        //prevent undefined

        vm.firstName = data.FirstName;
        vm.lastName = data.LastName;
        vm.middleInitial = data.MiddleName;
        vm.otherLastNames = data.OtherLastNames;
        vm.address = [vm.profile.HomeAddress.StreetLine1, vm.profile.HomeAddress.StreetLine2].filter(Boolean).join(', ');
        vm.apt = vm.profile.HomeAddress.AptNum;
        vm.stateProvince = vm.stateProvinces.find(x => x.Abbr === data.State);
        vm.city = data.City;
        vm.zip = data.ZipCode;
        vm.dob = data.DOB != null ? moment(data.DOB, 'MM/DD/YYYY').toDate() : null; //data.DOB != null ? new Date(data.DOB);
        vm.ssn = data.Ssn
        vm.email = data.EmailAddress;
        vm.telephone = data.Telephone
        //vm.cb1 = data.CB1;
        //vm.cb2 = data.CB2;
        //vm.cb3 = data.CB3;
        //vm.cb4 = data.CB4;
        if (data.CB1 === "true") {
            vm.cb = "d1";
        }
        if (data.CB2 === "true") {
            vm.cb = "d2";
        }
        if (data.CB3 === "true") {
            vm.cb = "d3";
        }
        if (data.CB4 === "true") {
            vm.cb = "d4";
        }

        if (data.CB3 === "true") {
            vm.uscis = data.USCISNumber
            /*validateStep3();*/
        }
        if (data.CB4 === "true") {
            vm.alienExpirationDate = data.AlienExpirationDate != null ? moment(data.AlienExpirationDate, 'MM/DD/YYYY').toDate() : null;
            vm.uscis2 = data.USCIS_ANumber;
            vm.i94 = data.I94Number;
            vm.foreignPassportNumber = data.ForeignPassportNumber;
            //validateStep4();
        }
        //if (vm.ownerView) {
        //    vm.signimage = data.Signature;
        //}
        if (data.Signature) {
            vm.signimage = data.Signature;
            vm.isSigned = true;
            vm.prefilled = true;
        }
        vm.date = moment(data.Date, 'MM/DD/YYYY').toDate();

        //employer defaults
        if (vm.employeeProfile.IcdOffices[0].HireDate != null) {
            vm.empDate = moment(vm.employeeProfile.IcdOffices[0].HireDate, 'MM/DD/YYYY').toDate();
        }


    }

    //event to track if user changed any form data
    //$scope.$watch(() => angular.toJson(vm.I9Form), function (newVal, oldVal) {
    //    if (newVal !== oldVal) {
    //        vm.prefilled = false;
    //    }
    //}, true);
    function onEditClicked() {
        vm.editable = !vm.editable;
        if (vm.employeeProfile != null && vm.employeeProfile.EmployeeStatusID === 1 && vm.application.ApplicationStatus === 'Pending') {
            vm.email = vm.profile.EmailAddress;
            vm.firstName = vm.profile.FirstName;
            vm.lastName = vm.profile.LastName;
            vm.middleInitial = vm.profile.MiddleName?.charAt(0) ?? null;
            vm.otherLastNames = null;
            // todo: check for deleted phone numbers
            vm.telephone = vm.profile?.HomePhone?.PhoneNumber;
            vm.dob = vm.profile.DateOfBirth;
            if (vm.profile.HomeAddress != null) {
                // todo: check if streetline2 needs to be added
                vm.address = [vm.profile.HomeAddress.StreetLine1, vm.profile.HomeAddress.StreetLine2].filter(Boolean).join(', ');
                vm.apt = vm.profile.HomeAddress.AptNum;
                vm.city = vm.profile.HomeAddress.City;
                /*vm.stateProvince = vm.stateProvinces.find(x => x.StateProvinceID === vm.profile.HomeAddress?.StateProvinceID)*/
                vm.zip = vm.profile.HomeAddress.PostalCode;
                vm.stateProvince = vm.stateProvinces.find(x => x.StateProvinceID === vm.profile.HomeAddress?.StateProvinceID);
            }
        }
    }

    $scope.$watch('vm.I9Form.$dirty', function (value) {
        // This is how we tell if there are unsaved form changes so we don't navigate away
        if (value) {
            vm.prefilled = false;
        }
    }, false);

    $scope.$watch('vm.cb', function (value, oldValue) {
        // This is how we tell if there are unsaved form changes so we don't navigate away
        if (value === oldValue || vm.isPrefilling) {
            return;
        }
        switch (value) {
            case "d1":
                resetDeclValidations();
                break;
            case "d2":
                resetDeclValidations();
                break;
            case "d3":
                resetDeclValidations();
                break;
            case "d4":
                resetDeclValidations();
                break;
        }

    }, false);

    function resetDeclValidations() {
        vm.I9Form.step41.$setValidity('required', true);
        vm.I9Form.step42.$setValidity('required', true);
        vm.I9Form.step43.$setValidity('required', true);
        vm.I9Form.alienexpdate.$setValidity('futureDate', true);
        vm.alienExpirationDate = '';
        vm.uscis = '';
        vm.uscis2 = '';
        vm.i94 = '';
        vm.foreignPassportNumber = '';
    }

    function onListToggle(toggle) {
        return onSaveAddlInputs(vm.employee.EmployeeID, "ListToggle", toggle);
    }

    function onSaveAddlInputs(employeeId, fieldName, value) {
        return onboardingDocumentService.setAddlInput(employeeId, fieldName, value);
    }

    function onToggleChange(isChecked) {
        validateFields(isChecked);
        onListToggle(isChecked);
    }

    function validateFields(isChecked) {
        if (!isChecked) {
            // When toggle is ON, select List A
            vm.selectedList = 'A';
            //clear b fields
            vm.documentTitleb = null;
            vm.issuingAuthorityb = null;
            vm.documentNumberb = null;
            vm.expirationDateb = null;

            vm.documentTitlec = null;
            vm.issuingAuthorityc = null;
            vm.documentNumberc = null;
            vm.expirationDatec = null;
            // validateListAFields();
        } else {
            // When toggle is OFF, select List B & C
            vm.selectedList = 'B';
            //clear a fields
            vm.documentTitle1 = null;
            vm.issuingAuthority1 = null;
            vm.documentNumber1 = null;
            vm.expirationDate1 = null;

            vm.documentTitle2 = null;
            vm.issuingAuthority2 = null;
            vm.documentNumber2 = null;
            vm.expirationDate2 = null;

            vm.documentTitle3 = null;
            vm.issuingAuthority3 = null;
            vm.documentNumber3 = null;
            vm.expirationDate3 = null;
            //validateListBFields();
        }
    }

    function validateListAFields() {
        //if (!vm.documentTitle1) {
        //    vm.I9Form.documentTitle1.$setValidity('required', false);
        //} else {
        //    vm.I9Form.documentTitle1.$setValidity('required', true);
        //}

        //if (!vm.issuingAuthority1) {
        //    vm.I9Form.issuingAuthority1.$setValidity('required', false);
        //} else {
        //    vm.I9Form.issuingAuthority1.$setValidity('required', true);
        //}
    };

    function validateListBFields() {
        //if (!vm.documentTitleb) {
        //    vm.I9Form.documentTitleb.$setValidity('required', false);
        //} else {
        //    vm.I9Form.documentTitleb.$setValidity('required', true);
        //}

        //if (!vm.issuingAuthorityb) {
        //    vm.I9Form.issuingAuthorityb.$setValidity('required', false);
        //} else {
        //    vm.I9Form.issuingAuthorityb.$setValidity('required', true);
        //}

        //if (!vm.documentTitlec) {
        //    vm.I9Form.documentTitlec.$setValidity('required', false);
        //} else {
        //    vm.I9Form.documentTitlec.$setValidity('required', true);
        //}

        //if (!vm.issuingAuthorityc) {
        //    vm.I9Form.issuingAuthorityc.$setValidity('required', false);
        //} else {
        //    vm.I9Form.issuingAuthorityc.$setValidity('required', true);
        //}
    };


    function onSign() {
        return $uibModal.open({
            ...SignaturePadModal,
            resolve: {
                title: () => "Changes to Time Entry"
            }
        }).result.then(function (data) {
            vm.signimage = data;
        });
    }

    function validateStep4() {
        //if (vm.cb !== 'd4') {
        //    vm.alienExpirationDate = '';
        //    vm.I9Form.step41.$setValidity('required', true);
        //    vm.I9Form.step42.$setValidity('required', true);
        //    vm.I9Form.step43.$setValidity('required', true);
        //    return;
        //}
        //if (vm.cb === 'd4' && !vm.uscis2 && !vm.i94 && !vm.foreignPassportNumber) {
        //    vm.I9Form.step41.$setValidity('required', false);
        //    vm.I9Form.step42.$setValidity('required', false);
        //    vm.I9Form.step43.$setValidity('required', false);
        //} else {
        //    vm.I9Form.step41.$setValidity('required', true);
        //    vm.I9Form.step42.$setValidity('required', true);
        //    vm.I9Form.step43.$setValidity('required', true);
        //}
    }

    function validateStep3() {
        vm.I9Form.step41.$setValidity('required', true);
        vm.I9Form.step42.$setValidity('required', true);
        vm.I9Form.step43.$setValidity('required', true);
        if (vm.cb !== 'd3') {
            vm.uscis = '';
        }
    }



    function validateEmployerDates(field, value) {
        if (value !== undefined && value !== null) {
            var selectedDate = new Date(value);
            var currentDate = new Date();

            if (selectedDate < currentDate) {
                vm.I9Form[field].$setValidity('futureDate', false);
            } else {
                vm.I9Form[field].$setValidity('futureDate', true);
            }
        } else {
            vm.I9Form[field].$setValidity('futureDate', true);
        }
    }

    function validateFutureDate() {
        if (vm.cb !== 'd4') {
            vm.I9Form.alienexpdate.$setValidity('futureDate', true);
            return;
        }
        var selectedDate = new Date(vm.alienExpirationDate);
        var currentDate = new Date();

        if (selectedDate < currentDate) {
            vm.I9Form.alienexpdate.$setValidity('futureDate', false);
        } else {
            vm.I9Form.alienexpdate.$setValidity('futureDate', true);
        }
    }


    function requestReview() {
        const trans = onboardingDocumentService.saveComment({
            ApplicationId: vm.application.ApplicationId,
            UserName: vm.owner.UserName,
            Text: vm.commentText,
        }).then((res) => {
            if (res) return onboardingDocumentService.setReviewRequired(vm.employee.EmployeeID, '3');
        }).then(() => {
            vm.close({ $value: 'ok' });
        }).catch((err) => {
            return $q.reject(err);
        });

        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(trans, 'Request review failed')
        );

    }



    //function handleAttestationChange() {
    //    if (vm.attestation !== 'pr') {
    //        vm.uscis = ''; // Clear the text input
    //    } else if (vm.attestation !== 'alien') {
    //        vm.alienExpirationDate = ''; // Clear the date input
    //        vm.i94 = '';
    //        vm.foreignPassportNumber = '';
    //        vm.countryOfIssue = '';
    //    }
    //}

    function handlePreparerChange() {
        if (vm.prepUsed === 'Yes') {
            $(".prep-block").slideDown('medium');
            const windowHeight = $(window).height();
            const documentHeight = $(document).height();
            const scrollEnd = documentHeight - windowHeight;
            $('html, body').animate({ scrollTop: scrollEnd }, 'slow');
        } else {
            $(".prep-block").slideUp('medium');
            vm.prepLastName = '';
            vm.prepFirstName = '';
            vm.prepAddress = '';
            vm.prepCity = '';
            vm.prepState = '';
            vm.prepZipCode = '';
            vm.prepSignature = '';
        }
    }



    $scope.$on('modal.closing', function (event, reason, closed) {
        if (reason !== 'ok') {
            return onClose(event);
        }
    });

    function onClose(event) {
        if (vm.I9Form && vm.I9Form.$dirty) {
            /* vm.close({ $value: 'cancel' });*/
            event.preventDefault();
            $uibModal.open({
                ...InfoModal,
                resolve: {
                    notification: () => {
                        return "Your form is not completed yet. Do you want to leave?"
                    },
                    state: () => {
                        return "application-status";
                    }
                },
                controller: function ConfirmModalController($uibModalInstance) {
                    'ngInject'
                    this.close = function () {
                        $uibModalInstance.dismiss();
                    };
                },
                size: 'sm',
                backdrop: 'static'
            }).result.then(function (data) {
                console.log(data);
                if (data === 'ok') {
                    vm.close({ $value: 'ok' });
                }
            }, function (dismiss) {
                console.log(dismiss);
            });
        }
    }

    function onShowDirectDeposit() {
        vm.close({ $value: 'ok' });
    }

    function onSave() {
        utilityService.showLoading();
        let formData = {
            RequestTypeId: '3',
            IsI9EmployeeMode: !vm.ownerView,
            FirstName: vm.firstName,
            MiddleName: vm.middleInitial,
            LastName: vm.lastName,
            OtherLastNames: vm.otherLastNames,
            Address: vm.address,
            ApartmentNumber: vm.apt,
            State: vm.stateProvince.Abbr,
            City: vm.city,
            ZipCode: vm.zip,
            DOB: moment(vm.dob, 'DD/MM/YYYY').format('MM/DD/YYYY'),
            Telephone: vm.telephone,
            EmployeeSocialSecurityNumber: vm.employeeBankInfo.CurrentSSN,
            EmailAddress: vm.email,
            CB1: vm.cb === 'd1',
            CB2: vm.cb === 'd2',
            CB3: vm.cb === 'd3',
            CB4: vm.cb === 'd4',
            USCISNumber: vm.uscis,
            USCIS_ANumber: vm.uscis2,
            AlienExpirationDate: vm.alienExpirationDate != null && vm.alienExpirationDate !== '' ? moment(vm.alienExpirationDate, 'DD/MM/YYYY').format('MM/DD/YYYY') : vm.alienExpirationDate,
            I94Number: vm.i94,
            ForeignPassportNumber: vm.foreignPassportNumber,
            Date: moment(vm.date, 'DD/MM/YYYY').format('MM/DD/YYYY'),
            Signature: vm.signimage
        };
        return onboardingDocumentService.save(vm.employee.UserName, formData, '0').then(function () {
            vm.I9Form.$setPristine();
            vm.isSaved = true;
            vm.showSavedNotification = true;
            return utilityService.hideLoading();
        });
    }

    

    function onApprove() {
        let approvePromise = onboardingDocumentService.approveOnboardingForm(vm.application.ApplicationId, "3");
        return $q.all(approvePromise).then((res) => {
            if (res) {
                vm.onShowDirectDeposit();
            }
        }).catch((err) => {
            return $q.reject(err);
        });

        //utilityService.showLoadingUntilResolved(
        //    utilityService.alertOnError(trans, "Approve failed")
        //);
    }

    function onSubmit() {
        if (vm.I9Form && vm.I9Form.$invalid) {
            alert("Form is invalid. Fill the required fields.");
            return false;
        }
        let updatePromises = [];
        let submitApplicationPromise = $q.defer();
        vm.isRehireDirty = vm.employeeProfile != null && (vm.employeeProfile.EmployeeStatusID === 1 || vm.employeeProfile.EmployeeStatusID === 3) && vm.application.ApplicationStatus === 'Pending';
        const isPendingResubmit = vm.application.ApplicationStatus === 'Pending'
            && (vm.application.I9Form === 'Approved' || vm.application.I9Form === 'Pending');
        if ((vm.I9Form && vm.I9Form.$dirty) || vm.savedData || vm.isSaved || vm.ownerView || vm.isRehireDirty || isPendingResubmit || vm.isSigned || vm.application.I9Form === 'ReviewRequired') {
            if (!vm.isSigned) {
                utilityService.hideLoading();
                alert("Preview and Signature is required");
            }
            if (!vm.signimage) {
                utilityService.hideLoading();
                alert("Signature is required");
                return;
            }
            if (!vm.employerSignimage && vm.ownerView) { //only for pages with employer signature
                utilityService.hideLoading();
                alert("Signature is required");
                return;
            }
            if (vm.cb === 'd4') {
                var selectedDate = new Date(vm.alienExpirationDate);
                var currentDate = new Date();

                if (selectedDate <= currentDate) {
                    vm.I9Form.alienexpdate.$setValidity('futureDate', false);
                    utilityService.hideLoading();
                    return;
                }
            }

            let formData = {
                RequestTypeId: '3',
                IsI9EmployeeMode: !vm.ownerView,
                FirstName: vm.firstName,
                MiddleName: vm.middleInitial,
                LastName: vm.lastName,
                OtherLastNames: vm.otherLastNames,
                Address: vm.address,
                ApartmentNumber: vm.apt,
                State: vm.stateProvince.Abbr,
                City: vm.city,
                ZipCode: vm.zip,
                DOB: moment(vm.dob, 'DD/MM/YYYY').format('MM/DD/YYYY'),
                Telephone: vm.telephone,
                EmployeeSocialSecurityNumber: vm.employeeBankInfo.CurrentSSN,
                EmailAddress: vm.email,
                CB1: vm.cb === 'd1',
                CB2: vm.cb === 'd2',
                CB3: vm.cb === 'd3',
                CB4: vm.cb === 'd4',
                USCISNumber: vm.uscis,
                USCIS_ANumber: vm.uscis2,
                AlienExpirationDate: vm.alienExpirationDate != null && vm.alienExpirationDate !== '' ? moment(vm.alienExpirationDate, 'DD/MM/YYYY').format('MM/DD/YYYY') : vm.alienExpirationDate,
                I94Number: vm.i94,
                ForeignPassportNumber: vm.foreignPassportNumber,
                Date: moment(vm.date, 'DD/MM/YYYY').format('MM/DD/YYYY'),
                Signature: vm.signimage
            };

            if (vm.ownerView) {
                let ownerData = {
                    DocTitleA1: vm.documentTitle1,
                    DocTitleA2: vm.documentTitle2,
                    DocTitleA3: vm.documentTitle3,
                    DocTitleB1: vm.documentTitleb,
                    DocTitleC1: vm.documentTitlec,
                    DocAuthorityA1: vm.issuingAuthority1,
                    DocAuthorityA2: vm.issuingAuthority2,
                    DocAuthorityA3: vm.issuingAuthority3,
                    DocAuthorityB1: vm.issuingAuthorityb,
                    DocAuthorityC1: vm.issuingAuthorityc,
                    DocNumberA1: vm.documentNumber1,
                    DocNumberA2: vm.documentNumber2,
                    DocNumberA3: vm.documentNumber3,
                    DocNumberB1: vm.documentNumberb,
                    DocNumberC1: vm.documentNumberc,
                    DocExpDateA1: vm.expirationDate1 != null ? moment(vm.expirationDate1, 'DD/MM/YYYY')?.format('MM/DD/YYYY') : vm.expirationDate1,
                    DocExpDateA2: vm.expirationDate2 != null ? moment(vm.expirationDate2, 'DD/MM/YYYY')?.format('MM/DD/YYYY') : vm.expirationDate2,
                    DocExpDateA3: vm.expirationDate3 != null ? moment(vm.expirationDate3, 'DD/MM/YYYY')?.format('MM/DD/YYYY') : vm.expirationDate3,
                    DocExpDateB1: vm.expirationDateb != null ? moment(vm.expirationDateb, 'DD/MM/YYYY')?.format('MM/DD/YYYY') : vm.expirationDateb,
                    DocExpDateC1: vm.expirationDatec != null ? moment(vm.expirationDatec, 'DD/MM/YYYY')?.format('MM/DD/YYYY') : vm.expirationDatec,
                    AdditionalInformation: vm.additionalInformation,
                    EmploymentFirstDay: vm.empDate != null ? moment(vm.empDate, 'DD/MM/YYYY').format('MM/DD/YYYY') : vm.empDate,
                    Employername: vm.employerName,
                    EmployerBusinessName: vm.employerBusinessName,
                    EmployerBusinessAddress: vm.employerBusinessAddress,
                    EmployerSignature: vm.employerSignimage,
                    TodaysDate: moment(vm.todaysDate, 'DD/MM/YYYY').format('MM/DD/YYYY')
                }
                formData = { ...formData, ...ownerData }
            }

            submitApplicationPromise = onboardingDocumentService.submit(vm.employee.UserName, formData, '0');
            updatePromises.push(submitApplicationPromise);
            //syncFormToProfile();
            //updatePromises.push(employeeService.updateEmployeeProfile(vm.employee.EmployeeID, vm.userProfile));
            //updatePromises.push(employeeService.updateEmployeeBankInfo(vm.employee.EmployeeID, vm.employeeBankInfo));
        }


        if (!Array.isArray(updatePromises) || updatePromises.length === 0) {
            if (vm.ownerView) {
                return onApprove();
            } else {
                return onShowDirectDeposit();
            }

        }

        const trans = $q.all(updatePromises).then((res) => {
            if (res) {
                if (vm.ownerView) {
                    return onApprove();
                } else {
                    return onShowDirectDeposit();
                }

            }
        }).catch((err) => {
            return $q.reject(err);
        });

        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(trans, "Save failed")
        );
    }

    function onPreviewInPage() {
        if (vm.I9Form && vm.I9Form.$invalid) {
            alert("Form is invalid. Fill the required fields.");
            return false;
        }
        utilityService.showLoading();
        let formData = {
            RequestTypeId: '3',
            IsI9EmployeeMode: !vm.ownerView,
            FirstName: vm.firstName,
            MiddleName: vm.middleInitial,
            LastName: vm.lastName,
            OtherLastNames: vm.otherLastNames,
            Address: vm.address,
            ApartmentNumber: vm.apt,
            State: vm.stateProvince.Abbr,
            City: vm.city,
            ZipCode: vm.zip,
            DOB: vm.dob.toLocaleDateString(),
            Telephone: vm.telephone,
            EmployeeSocialSecurityNumber: vm.employeeBankInfo.CurrentSSN,
            EmailAddress: vm.email,
            CB1: vm.cb === 'd1',
            CB2: vm.cb === 'd2',
            CB3: vm.cb === 'd3',
            CB4: vm.cb === 'd4',
            USCISNumber: vm.uscis,
            USCIS_ANumber: vm.uscis2,
            AlienExpirationDate: vm.alienExpirationDate != null && vm.alienExpirationDate !== '' ? moment(vm.alienExpirationDate, 'DD/MM/YYYY')?.format('MM/DD/YYYY') : vm.alienExpirationDate,
            I94Number: vm.i94,
            ForeignPassportNumber: vm.foreignPassportNumber,
            //CountryOfIssue: vm.countryOfIssue,
            //TodaysDate: moment(vm.todaysDate).format('DD/MM/YYYY'),
            Date: moment(vm.date, 'DD/MM/YYYY').format('MM/DD/YYYY')
            //Signature: vm.signimage
        };

        return onboardingDocumentService.previewUrl(vm.employee.UserName, formData, '0').then(function (result) {
            utilityService.hideLoading();
            vm.previewUrl = result;
            return $uibModal.open({
                ...PreviewSignatureModal,
                resolve: {
                    title: () => "I9 Preview",
                    previewUrl: () => {
                        return vm.previewUrl;
                    }
                }
            }).result
        }).then(function (data) {
            console.log(data);
            vm.signimage = data.dataUrl;
            vm.isSigned = data.dataUrl != null;
            //vm.ISPreview = true;
            return onSubmit();
        }).catch((err) => {
            utilityService.hideLoading();
            console.log(err)
        });
    }

    function onDocDownload(type, pages) {
        utilityService.showLoading();
        return onboardingDocumentService.retrieveTemplate(vm.employee.UserName, '1', '0', pages).then(function (result) {
            utilityService.hideLoading();
            return result;
        }).catch((err) => {
            utilityService.hideLoading();
            console.log(err)
        });
    }

    function onPreview() {
        if (vm.I9Form && vm.I9Form.$invalid) {
            alert("Form is invalid. Fill the required fields.");
            return;
        }
        if (!vm.selectedList) {
            alert("Select Document List.");
            return;
        }
        utilityService.showLoading();
        let formData = {
            RequestTypeId: '3',
            IsI9EmployeeMode: !vm.ownerView,
            FirstName: vm.firstName,
            MiddleName: vm.middleInitial,
            LastName: vm.lastName,
            OtherLastNames: vm.otherLastNames,
            Address: vm.address,
            ApartmentNumber: vm.apt,
            State: vm.stateProvince.Abbr,
            City: vm.city,
            ZipCode: vm.zip,
            DOB: vm.dob.toLocaleDateString(),
            Telephone: vm.telephone,
            EmployeeSocialSecurityNumber: vm.employeeBankInfo.CurrentSSN,
            EmailAddress: vm.email,
            CB1: vm.cb === 'd1',
            CB2: vm.cb === 'd2',
            CB3: vm.cb === 'd3',
            CB4: vm.cb === 'd4',
            USCISNumber: vm.uscis,
            USCIS_ANumber: vm.uscis2,
            AlienExpirationDate: vm.alienExpirationDate != null && vm.alienExpirationDate !== '' ? moment(vm.alienExpirationDate, 'DD/MM/YYYY')?.format('MM/DD/YYYY') : vm.alienExpirationDate,
            I94Number: vm.i94,
            ForeignPassportNumber: vm.foreignPassportNumber,
            //CountryOfIssue: vm.countryOfIssue,
            //TodaysDate: moment(vm.todaysDate).format('DD/MM/YYYY'),
            Date: moment(vm.date, 'DD/MM/YYYY').format('MM/DD/YYYY'),
            Signature: vm.signimage
        };
        if (vm.ownerView) {
            let ownerData = {
                DocTitleA1: vm.documentTitle1,
                DocTitleA2: vm.documentTitle2,
                DocTitleA3: vm.documentTitle3,
                DocTitleB1: vm.documentTitleb,
                DocTitleC1: vm.documentTitlec,
                DocAuthorityA1: vm.issuingAuthority1,
                DocAuthorityA2: vm.issuingAuthority2,
                DocAuthorityA3: vm.issuingAuthority3,
                DocAuthorityB1: vm.issuingAuthorityb,
                DocAuthorityC1: vm.issuingAuthorityc,
                DocNumberA1: vm.documentNumber1,
                DocNumberA2: vm.documentNumber2,
                DocNumberA3: vm.documentNumber3,
                DocNumberB1: vm.documentNumberb,
                DocNumberC1: vm.documentNumberc,
                DocExpDateA1: vm.expirationDate1 != null ? moment(vm.expirationDate1, 'DD/MM/YYYY')?.format('MM/DD/YYYY') : vm.expirationDate1,
                DocExpDateA2: vm.expirationDate2 != null ? moment(vm.expirationDate2, 'DD/MM/YYYY')?.format('MM/DD/YYYY') : vm.expirationDate2,
                DocExpDateA3: vm.expirationDate3 != null ? moment(vm.expirationDate3, 'DD/MM/YYYY')?.format('MM/DD/YYYY') : vm.expirationDate3,
                DocExpDateB1: vm.expirationDateb != null ? moment(vm.expirationDateb, 'DD/MM/YYYY')?.format('MM/DD/YYYY') : vm.expirationDateb,
                DocExpDateC1: vm.expirationDatec != null ? moment(vm.expirationDatec, 'DD/MM/YYYY')?.format('MM/DD/YYYY') : vm.expirationDatec,
                AdditionalInformation: vm.additionalInformation,
                EmploymentFirstDay: vm.empDate != null ? moment(vm.empDate, 'DD/MM/YYYY').format('MM/DD/YYYY') : vm.empDate,
                Employername: vm.employerName,
                EmployerBusinessName: vm.employerBusinessName,
                EmployerBusinessAddress: vm.employerBusinessAddress,
                TodaysDate: moment(vm.todaysDate, 'DD/MM/YYYY').format('MM/DD/YYYY')
            }
            formData = { ...formData, ...ownerData }
        }
        return onboardingDocumentService.previewUrl(vm.employee.UserName, formData, '0').then(function (result) {
            utilityService.hideLoading();
            vm.previewUrl = result;
            return $uibModal.open({
                ...OwnerPreviewSignatureModal,
                resolve: {
                    title: () => "I9 Preview",
                    previewUrl: () => {
                        return vm.previewUrl;
                    },
                    allowApprove: () => {
                        return canApproveForm(vm.application, '3');
                    },
                    allowSign: () => {
                        return true;
                    },
                    acknowledgement: () => {
                        return "By signing and submitting this document, you acknowledge that you have reviewed the documents provided by the Rep and is entered correctly into the I9.";
                    }
                }
            }).result
        }).then(function (data) {
            console.log(data);
            vm.employerSignimage = data.dataUrl;
            vm.isSigned = data.dataUrl != null;
            //vm.ISPreview = true;
            return onSubmit();
        }).catch((err) => {
            utilityService.hideLoading();
            console.log(err)
        });

    }

    function cancel() {

    }


    function onChangeCB(event) {
        console.log(event);
    }

    function retrieveLocaleTranslations(localeID) {
        return localeService.retrieveLocaleTranslations(localeID)
            .then(function (translations) {
                return translations;
            });
    }

    function retrieveLocale() {
        return localeService.retrieveLocales()
            .then(function (locales) {
                console.log(vm.employeeBankInfo.CountryID);
                return locales.filter(function (locale) {
                    console.log(vm.employeeBankInfo.CountryID);
                    return locale.countryID === vm.employeeBankInfo.CountryID;
                })[0] || localeService.retrieveCurrentLocale();
            })
            .then(function (locale) {
                if (locale) {
                    return locale;
                }
            });
    }

    function ssnIsValidated() {
        if (vm.employeeBankInfo != null && vm.employeeBankInfo.ssnChanged) {
            if ((vm.employeeBankInfo.SSN || "") !== (vm.employeeBankInfo.confirmSSN || "")) {
                return false;
            }
        }
        return true;
    }

    function ssnBlur() {
        if (vm.employeeBankInfo != null && vm.employeeBankInfo.SSN !== vm.employeeBankInfo.originalSSN) {
            vm.employeeBankInfo.ssnChanged = true;
        } else {
            vm.employeeBankInfo.ssnChanged = false;
        }
    }

    function revealSSNChar(ssn, char, i) {
        return i > 4;
    }
    function revealFEINChar(fein, char, i) {
        return i > 4;
    }
}


export const I9Modal = {
    component: "apexI9Modal",
    windowClass: 'xx-dialog pagespinner',
    size: 'lg',
    backdrop: 'static'
}

